import { useDeleteDataCaptureFormById } from 'api/services/dataCaptureService';
import { GenericDeleteModal } from 'components/ui/GenericDeleteModal';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import { useTranslation } from 'react-i18next';
import { ErrorType } from 'types/genericTypes';

interface DeleteDataCaptureFormModalProps {
  open: boolean;
  onCancel: () => void;
  dataCaptureFormId: string;
}

export const DeleteDataCaptureFormModal = ({
  open,
  onCancel,
  dataCaptureFormId,
}: DeleteDataCaptureFormModalProps) => {
  const { t } = useTranslation();
  const { openNotification } = useFloatNotification();
  const { mutateAsync: deleteDataCaptureForm } = useDeleteDataCaptureFormById();

  const handleConfirm = async () => {
    try {
      await deleteDataCaptureForm(dataCaptureFormId);
      openNotification(
        t('success'),
        t('data-capture-list-view.delete-modal-success'),
        'success'
      );
    } catch (err) {
      const apiError = err as ErrorType;
      if (apiError.body?.errorCode) {
        openNotification(t('error'), t(apiError.body.errorCode), 'error');
      } else {
        openNotification(
          t('error'),
          t('data-capture-list-view.delete-modal-error'),
          'error'
        );
      }
    }
    onCancel();
  };

  return (
    <GenericDeleteModal
      open={open}
      onCancel={onCancel}
      onOk={handleConfirm}
      confirmLoading={false}
      bodyText={t('data-capture-list-view.delete-modal-body')}
    />
  );
};
